import React from 'react';
import { FileText, CheckCircle, Clock, Users, MapPin, Building } from 'lucide-react';

const StatsOverview = ({ data }) => {
  const stats = [
    {
      title: 'Total Grievances',
      value: data.totalGrievance,
      icon: FileText,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700'
    },
    {
      title: 'Grievances Resolved',
      value: data.resolvedGrievances,
      icon: CheckCircle,
      color: 'bg-green-500',
      // bgColor: 'bg-green-50',
      bgColor: 'bg-blue-50',
      textColor: 'text-green-700'
    },
    {
      title: 'Grievances In Progress',
      value: data.inProgressGrievances,
      icon: Clock,
      color: 'bg-orange-500',
      // bgColor: 'bg-orange-50',
      bgColor: 'bg-blue-50',
      textColor: 'text-orange-700'
    },
    {
      title: 'Active DEO',
      value: data.activeDEO,
      icon: Users,
      color: 'bg-purple-500',
      // bgColor: 'bg-purple-50',
      bgColor: 'bg-blue-50',
      textColor: 'text-purple-700'
    },
    {
      title: 'Wards',
      value: data.totalWards,
      icon: MapPin,
      color: 'bg-indigo-500',
      // bgColor: 'bg-indigo-50',
      bgColor: 'bg-blue-50',
      textColor: 'text-indigo-700'
    },
    {
      title: 'Offices',
      value: data.totalOffices,
      icon: Building,
      color: 'bg-teal-500',
      // bgColor: 'bg-teal-50',
      bgColor: 'bg-blue-50',
      textColor: 'text-teal-700'
    }
  ];

  return (
    <div className="grid grid-cols-6 gap-4 h-full">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            className={`${stat.bgColor} rounded-lg p-3 border border-gray-100 hover:shadow-md transition-all duration-200 overview-card`}
          >
            <div className="flex items-center justify-center gap-3">
              <div className={`${stat.color} p-2 rounded-full`}>
                <Icon size={18} className="text-white" />
              </div>
            </div>
            <div className='flex flex-col justify-center items-center'>
              <p className="text-xl font-bold text-gray-900 mb-1">
                {stat.value.toLocaleString()}
              </p>
              <p className={`text-xs font-medium ${stat.textColor} text-center`}>
                {stat.title}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsOverview;
